<template>
  <div class="appData">
    <el-col :span="14" style="width:100%">
      <div class="grid-content bg-purple newsNav">
        <el-tabs v-model="activeName" @tab-click="handleClick">
        
          <el-tab-pane label="APP下载" name="first">
            <!-- APP下载 -->
           <div class="appDownload">

             <!-- 学生端 -->
             <div class="app-student">
               <div>美德少年--学生端</div>
               <div class="downloadContent">
                 <!-- andriod -->
                <div class="appIphone">
                  <img class="erweimaImg" :src="studentAppImg" alt="下载二维码">
                  <!-- <el-link class="AndroidAPP" type="success" :href="androidStudentApp" ><i class="el-icon-download"></i> 安卓下载</el-link> -->
                </div>
                <!-- ios -->
                <div class="appIphone">
                  <img class="erweimaImg" :src="iosStudentAppImg" alt="下载二维码">
                  <!-- <el-button class="iosApp" :plain="true" @click="open"><i class="el-icon-download"></i> App store</el-button> -->
                  <!-- <el-link class="iosApp" type="warning" :href="iosStudentApp" ><i class="el-icon-download"></i> App store下载</el-link> -->
                </div>
               </div>
             </div>
            <el-divider direction="vertical" content-position="center"></el-divider>
            

             <!-- 家长端 -->
             <div class="app-parents">
               <div>美德少年--家长端</div>
               <div class="downloadContent">
                 <div class="appIphone">
                 <img class="erweimaImg" :src="parentsAppImg" alt="下载二维码">
                   <!-- <el-link class="AndroidAPP" type="success" :href="androidParentsApp"><i class="el-icon-download"></i> 安卓下载</el-link> -->
                 </div>
                 <div class="appIphone">
                 <img class="erweimaImg" :src="iosParentsAppImg" alt="下载二维码">
                   <!-- <el-link class="iosApp" type="warning" :href="iosParentsApp" ><i class="el-icon-download"></i> App store</el-link> -->
                 </div>
               </div>
             </div>
           </div>


           <!-- APP介绍 -->
           <div class="appContent">
             <div>
              <div>美德少年，是一款寓教于乐的情景再现德育系统，以中学养德、西学养功为原则。内容上实现中华传统美德与世界优秀品德的有机结合，并实现科学理性与社会主义核心价值观的有机结合。通过情景再现模拟技术与设计，让每一个小孩子都在情景中切身体会美德与理性之光，同时在线下与父母形成良性的亲自关系，与朋友同学形成和谐的互助关系。久而久之，习惯成自然，知识转实惠。</div>
              <div class="logoContent">
                <img src="static/image/virtueLogo.png" alt="logo" class="logo">
                <h3 class="cultureTittle">{{ footContent }}</h3>
              </div>
             </div>
              <img class="appContentImg" src="../../static/image/appStart.png" alt="">
           </div>

          </el-tab-pane>

          <el-tab-pane label="版本更新" name="second">
            <div
              class="news"
              v-for="(item, index) in $store.state.newsList"
              :key="index"
            >
              <div class="left">
                <div class="newsType">{{ item.newsType }}</div>
                <div class="newsTittle">{{ item.newsTittle }}</div>
              </div>
              <div class="newsDate">{{ item.newsDate }}</div>
            </div>
          </el-tab-pane>

 
        </el-tabs>
      </div>
    </el-col>

    <!-- <div class="block">
      <el-pagination layout="prev, pager, next" :total="50"> </el-pagination>
    </div> -->

    <router-view />
  </div>
</template>

<script scoped>
export default {
  data() {
    return {
      activeName: "first",
      footContent: "美德少年，热爱集体，孝敬父母，与人为善，和谐共处",

      // 学生端iOS
      iosStudentAppImg:'../../static/image/studentDownload_iOS.png',
      iosStudentApp:'https://apps.apple.com/cn/app/%E7%BE%8E%E5%BE%B7%E5%B0%91%E5%B9%B4/id1579638019',
      // 学生端安卓
      studentAppImg:'../../static/image/studentDownload_andriod.png',
      androidStudentApp:'http://sdwd.neccc.cn/data/APP/%E5%AD%A6%E7%94%9F%E7%AB%AF/%E7%BE%8E%E5%BE%B7%E5%B0%91%E5%B9%B4.apk',
      // 家长端iOS
      iosParentsAppImg:'../../static/image/parentDownload_ios.png',
      iosParentsApp:'https://apps.apple.com/cn/app/%E7%BE%8E%E5%BE%B7%E5%B0%91%E5%B9%B4-%E5%AE%B6%E9%95%BF%E7%AB%AF/id1579273594',
      //家长端安卓
      parentsAppImg:'../../static/image/parentDownload_Android.png',
      androidParentsApp:'http://sdwd.neccc.cn/data/APP/%E5%AE%B6%E9%95%BF%E7%AB%AF/%E7%BE%8E%E5%BE%B7%E5%B0%91%E5%B9%B4%E5%AE%B6%E9%95%BF%E7%AB%AF.apk',

    };
  },

  created(){
    // this.appDownlod();
  },

  methods: {
     open() {
        this.$message({
          showClose: true,
          message: 'app store暂未上线，敬请等待',
          type: 'warning'
        });
      },

    // appDownlod() {
    //   // 发送 POST 请求
    //   this.$axios
    //     .get("http://sdwd.neccc.cn/data/APP/remote_resource/appDownload.json")
    //     .then(function(res) {
    //       console.log(res.data);
    //       // 学生端
    //       this.studentAppImg=res.data.student.andriod.studentAppImg;
    //       this.androidStudentApp=res.data.student.andriod.studentApp;
    //       this.iosStudentApp=res.data.student.IOS.studentApp;
    //       // 家长端
    //       this.parentsAppImg=res.data.parents.andriod.parentsAppImg;
    //       this.androidParentsApp=res.data.parents.andriod.parentsApp;
    //       this.iosParentsApp=res.data.parents.IOS.parentsApp;

    //     });
    // },

    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style>
.appData {
  background: #ffffe6;
  border: 2px solid #89c33f;
  margin: 5% 0;
  padding: 5%;
  color: #603813;
  /* font-size: 14px; */
  /* height: 500px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* font-weight: bold; */
}
.newsNav {
  width: 100%;
  font-size: 14px;
}
.news {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  font-size: 14px;
}

.el-tabs__active-bar {
  display: none;
}
.el-tabs__nav-wrap::after {
  display: none;
}
.el-col-14 {
  width: 100%;
}
.left {
  display: flex;
  margin: 0;
}
.el-pagination button:disabled {
  background-color: #ffffe6;
}
.el-pager li {
  background-color: #ffffe6;
}
.el-pagination .btn-next {
  background-color: #ffffe6;
}


.appDownload {
  display: flex;
  justify-content: center;
}
.erweimaImg {
  width: 70%;
  height: 30%;
}
.downloadContent {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.iosApp {
  font-size: 10px;
  color: #F1AE04;
  border: #F1AE04 1px solid;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 5px;
  padding: 3px;
}
.AndroidAPP {
font-size: 10px;
  color: #89C33F;
  border: #89C33F 1px solid;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 5px;
  padding: 3px;
}
/* .app-student {
  display: flex;
  flex-direction: column;
} */

.appContent {
  margin-top: 30px;
  font-size: 10px;
  line-height: 20px;
  display: flex;
}
.appContentImg {
  width: 50%;
  margin-left: 10px;
}
.appIphone {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 10%;
  margin-right: 1%;
}
.logoContent {
  display: flex;
  align-items: center;
}


@media screen and (max-width: 700px) {
.appContent {
  flex-direction: column;
}
.appContentImg {
  width: 100%;
}
}
</style>



// WEBPACK FOOTER //
// src/components/appData.vue